import { useEffect, useState } from 'react';
// Apis
import { fetchRelationship } from 'Shared/api/PiInspire.api';
// Hooks
import { useOrganization } from './use-organization';
// Types
import { RelationshipInfo } from 'Shared/types/Relationship.type';
// Utils
import { getRelationshipData } from 'Shared/utils/piDemoData.utils';
import { useCurrentUser } from './use-current-user';

type Props = {
  person1: string;
  person2: string;
};

export const useRelationshipGuide = ({ person1, person2 }: Props) => {
  const { organization, isPiDemoAccount } = useOrganization();
  const [relationship, setRelationship] = useState<RelationshipInfo | null>(null);
  const [loading, setLoading] = useState<boolean | null>(true);
  const [error, setError] = useState(null);
  const { user } = useCurrentUser();
  const strengths: string[] = relationship?.relationshipGuideDetails.map(x => x.relationshipStrengthsKey);
  const cautions: string[] = relationship?.relationshipGuideDetails.map(x => x.relationshipCautionsKey);
  const tips: string[] = relationship?.relationshipGuideDetails.map(x => x.relationshipTipsKey);

  useEffect(() => {
    let isMounted = true;
    const getRelationships = async () => {
      try {
        if (isPiDemoAccount) {
          const demodata = getRelationshipData(person1, person2, user.first_name);
          setRelationship(demodata);
          return;
        }
        if (organization.pi_company_guid) {
          const response = await fetchRelationship({
            companyGuid: organization.pi_company_guid,
            person1: person1,
            person2: person2,
          });
          if (response.status != 200) {
            throw new Error('Network response was not ok for Inspire Api');
          }
          const data: RelationshipInfo = await response.data;
          if (isMounted) {
            setRelationship(data);
          }
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getRelationships();
    return () => {
      isMounted = false;
    };
  }, []);

  return {
    relationship,
    strengths,
    cautions,
    tips,
    loading,
    error,
  };
};
